import React from "react";
import { Product } from "@/types/types";
import { TickOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { CompetitorList } from "./CompetitorList";
import styles from "./PricePromiseDrawer.module.scss";

interface PricePromiseDrawerProps {
  product: Product;
  isOpen: boolean;
  onClose: () => void;
  isJohnLewisProduct?: boolean;
}

const TICK_SIZE = "large";

export const PricePromiseDrawer: React.FC<PricePromiseDrawerProps> = ({
  product,
  isOpen,
  onClose,
  isJohnLewisProduct = false,
}) => {
  function handlePricePromiseURLClick(): void {
    dispatchMonetateQEvent("pdp:price-promise:url-displayed");
    window.location.href =
      "https://www.johnlewis.com/customer-services/prices-and-payment/price-promise?source=pricepromisedrawer";
  }

  return (
    <Drawer heading="Our price promise" isOpen={isOpen} onClose={onClose}>
      <div className={styles.drawerBody}>
        {isJohnLewisProduct ? (
          <>
            <h3 className={styles.subHeading}>We match our own prices too</h3>
            <ul className={styles.tickList}>
              <li>
                <TickOutlined size={TICK_SIZE} /> If we drop the price up to 7
                days after you buy, you can request a refund for the difference.
              </li>
            </ul>
          </>
        ) : (
          <>
            <h3 className={styles.subHeading}>
              We&apos;re already price matching this item
            </h3>
            <ul className={styles.tickList}>
              <li>
                <TickOutlined size={TICK_SIZE} /> We automatically check our
                prices against 25 top retailers, and if we find a better price
                we&apos;ll match it
              </li>
              <li>
                <TickOutlined size={TICK_SIZE} /> If they drop the price up to 7
                days after you buy, you can request a refund for the difference.
                You can also do this if we drop the price ourselves.
              </li>
              <li>
                <TickOutlined size={TICK_SIZE} /> We even match promotions and
                seasonal offers, exclusions apply.
              </li>
            </ul>
          </>
        )}
        <UnderlinedButton
          tag="a"
          href="https://www.johnlewis.com/customer-services/prices-and-payment/price-promise?source=pricepromisedrawer"
          onClick={handlePricePromiseURLClick}
          className={styles.moreInfoLink}
          labelText={
            isJohnLewisProduct
              ? "How to request a refund"
              : "How our price promise works"
          }
        />
        {!isJohnLewisProduct && <CompetitorList product={product} />}
      </div>
      <footer className={styles.drawerFooter}>Never knowingly undersold</footer>
    </Drawer>
  );
};
